var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.displayFormat)?_c('input',_vm._b({attrs:{"type":"text"},domProps:{"value":_vm.displayCurrency},on:{"focus":_vm.forcusInput}},'input',_vm.$attrs,false)):_c('input',_vm._b({ref:"input_num",attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"blur":_vm.loseForcus,"input":_vm.onInput}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }